// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r9uT","colBig":"styles_colBig__13jp2","colSmall":"styles_colSmall__GuSLR"};